'use client';
import { useSession } from '@/providers/session-provider';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

export function useGetSocketToken() {
  const {
    data: { session },
  } = useSession();
  const userId = session?.userId;
  const token = session?.token;
  const customerId = session?.customerId;
  const pathname = usePathname();
  const base64Token = useMemo(() => {
    if (!userId || !token || !customerId || pathname.includes('login')) {
      return null;
    }
    return btoa(`${customerId}.${userId}:${token}`);
  }, [customerId, pathname, token, userId]);

  return base64Token;
}
